import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
// import TabContext from '@mui/lab/TabContext';
// import TabList from '@mui/lab/TabList';
// import TabPanel from '@mui/lab/TabPanel';
import ProjectManagement from '../projectManagement/ProjectManagement';
import { Tabs } from '@mui/material';
import OrganizationManagement from '../organisationManagement/OrganisationManagement';
import LocationManagement from '../locationManagement/LocationManagement';
import AssignmentManagement from '../assignmentManagement/AssignmentManagement';
import SurveyManagement from '../surveyManagement/SurveyManagement';


function CustomTabPanel(props) {
  const { children, value, index=0, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}


function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
function TaskManager() {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };
    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
          {/* <Tabs value={value}> */}
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange} aria-label="lab API tabs example">
                <Tab label="Project Management" {...a11yProps(0)}/>
                <Tab label="Organization Management" {...a11yProps(1)}/>
                <Tab label="Location Management" {...a11yProps(2)} />
                <Tab label="Assignment Management" {...a11yProps(3)} />
                <Tab label="Survey Management" {...a11yProps(3)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}><ProjectManagement/></CustomTabPanel>
            <CustomTabPanel value={value} index={1}><OrganizationManagement/></CustomTabPanel>
            <CustomTabPanel value={value} index={2}><LocationManagement/></CustomTabPanel>
            <CustomTabPanel value={value} index={3}><AssignmentManagement/></CustomTabPanel>
            <CustomTabPanel value={value} index={4}><SurveyManagement/></CustomTabPanel>
          {/* </Tabs> */}
          {/* <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleChange} aria-label="lab API tabs example">
                <Tab label="Project Management" value="1" />
                <Tab label="Item Two" value="2" />
                <Tab label="Item Three" value="3" />
              </TabList>
            </Box>
            <TabPanel value="1"><ProjectManagement/></TabPanel>
            <TabPanel value="2">Item Two</TabPanel>
            <TabPanel value="3">Item Three</TabPanel>
          </TabContext> */}
        </Box>
      )
}

export default TaskManager
